import { ValidationError } from "ajv";
import { email, nonEmpty, object, parse, pipe, string } from "valibot";

import { ParticipantTypes } from "@api/graphql";
import { ValidationErrors } from "@pages/register/hooks/errorResolver";
import { UserDetailsInput } from "@pages/register/steps/RegisterFormTypes";

export const financeContactErrorResolver = async (
  data: UserDetailsInput,
  accountStatus?: string,
  participantTypes?: ParticipantTypes[],
): Promise<{ values: UserDetailsInput; errors: ValidationErrors<UserDetailsInput> }> => {
  const errors: ValidationErrors<UserDetailsInput> = {};

  const isAmpCmoArtCentre = participantTypes?.some((type) =>
    [ParticipantTypes.AMP, ParticipantTypes.CMO, ParticipantTypes.ART_CENTRE].includes(type),
  );
  const isFieldMandatory = isAmpCmoArtCentre && (accountStatus === "ACTIVE" || accountStatus === "PENDING_APPROVAL");

  if (isFieldMandatory && !data.finance_contact?.first_name) {
    errors.finance_contact = {
      ...errors.finance_contact,
      first_name: {
        type: "required",
        message: "First name is required.",
      },
    };
  }

  if (isFieldMandatory && !data.finance_contact?.last_name) {
    errors.finance_contact = {
      ...errors.finance_contact,
      last_name: {
        type: "required",
        message: "Last name is required.",
      },
    };
  }

  if (isFieldMandatory && !data.finance_contact?.finance_email) {
    errors.finance_contact = {
      ...errors.finance_contact,
      finance_email: {
        type: "required",
        message: "Email address is required.",
      },
    };
  }

  if (isFieldMandatory && !data.finance_contact?.finance_phone) {
    errors.finance_contact = {
      ...errors.finance_contact,
      finance_phone: {
        type: "required",
        message: "Mobile number is required.",
      },
    };
  }

  const financeContactSchema = object({
    finance_email: pipe(string(), nonEmpty("Email is required."), email("Invalid email address format.")),
  });

  try {
    parse(financeContactSchema, {
      finance_email: data.finance_contact?.finance_email ?? "",
    });
  } catch (error: unknown) {
    if (error instanceof ValidationError) {
      errors.finance_contact = {
        ...errors.finance_contact,
        finance_email: {
          type: "pattern",
          message: error.message,
        },
      };
    } else {
      console.error("Unexpected error during validation:", error);
    }
  }

  return {
    values: data,
    errors,
  };
};
